import { GridColumn } from '@shared/modules/grid/abstractions';

export function checkVisibility(column: GridColumn): GridColumn {
  const gridColumn = <Required<GridColumn>>column;
  const visibilityResolver = gridColumn.filterableColumn.isVisible;
  if (visibilityResolver !== undefined) {
    if (typeof visibilityResolver === 'function') {
      gridColumn.filterableColumn.isVisible = visibilityResolver(
        gridColumn.filterableColumn
      );
    }
  } else {
    gridColumn.filterableColumn.isVisible = true;
  }
  return column;
}
